import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_EQM1011_R01 } from "./Content_EQM1011_R01";
import { SearchSection_EQM1011_R01 } from "./SearchSection_EQM1011_R01";
import { Table_EQM1011_R01 } from "./Table_EQM1011_R01";

export const Container_EQM1011_R01 = () => {
    const { setMessage } = useUiuxStore();
    const { fetchData, handleInitClick } = Content_EQM1011_R01({ setMessage });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined}
                onDeleteClick={() => {}}
                onInitClick={handleInitClick}
                onExcelClick={undefined}
                onPrintClick={() => {}}
            />
            <SearchSection_EQM1011_R01 />
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
                <div className="h-full w-full">
                    <Table_EQM1011_R01 />
                </div>
            </div>
            <Message />
        </div>
    );
};
